<template>
  <div>
    <VOverlayIntro :loadingIntro="loadingIntro" />
    <main-header-plat-a />
    <v-row class="d-flex flex-wrap flex-sm-nowrap">
      <v-col xs="12" sm="6" md="5" class="pl-0 ml-0">
        <v-container class="mt-2">
          <v-card>
            <v-row class="fill-height">
              <v-col>
                <v-sheet height="64">
                  <v-toolbar flat>
                    <v-row>
                      <v-col cols="12" class="py-0">
                        <v-toolbar-title v-if="$refs.calendar">
                          {{ $refs.calendar.title }}
                        </v-toolbar-title>
                      </v-col>
                      <v-col cols="9" class="pt-0 pb-2">
                        <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                          Hoy
                        </v-btn>
                        <v-btn fab text small color="grey darken-2" @click="prev">
                          <v-icon small> mdi-chevron-left </v-icon>
                        </v-btn>
                        <v-btn fab text small color="grey darken-2" @click="next">
                          <v-icon small> mdi-chevron-right </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-toolbar>
                </v-sheet>
                <v-sheet height="1200">
                  <div class="calendar-wrapper" style="position: relative; min-height: 500px;">
                    <v-fade-transition>
                      <v-overlay
                        v-if="loadingEvents"
                        absolute
                        color="white"
                        opacity="1"
                        z-index="5"
                      >
                        <div class="text-center">
                          <v-progress-circular
                            indeterminate
                            color="primary"
                            size="64"
                          ></v-progress-circular>
                          <div class="mt-2 primary--text font-weight-medium">
                            Cargando eventos...
                          </div>
                        </div>
                      </v-overlay>
                    </v-fade-transition>

                    <v-calendar
                      ref="calendar"
                      v-model="focus"
                      :events="events" 
                      :event-color="getEventColor"
                      :type="type"
                      @click:event="showEvent"
                      @click:more="viewDay"
                      @click:date="viewDay"
                      :key="events.length"
                      first-time="04:00"
                      :interval-count="20"
                      color="primary"
                    >
                    <template v-slot:event="{ event, timeSummary }">
                      <div class="px-1 text-truncate" style="line-height: 1.2; font-size: 11px;">
                        <b>{{ event.name }}</b>
                        
                        <!-- Se agregan los paréntesis para invocar la función de Vuetify -->
                        <span v-if="timeSummary">, {{ timeSummary() }}</span>
                        <span v-if="event.patientNameAbrev">, Pac. {{ event.patientNameAbrev }}</span>
                        <span v-if="event.details">, {{ event.details }}</span>
                      </div>
                    </template>
                    </v-calendar>
                  </div>

                  <v-menu
                    v-model="selectedOpen"
                    :close-on-content-click="false"
                    :activator="selectedElement"
                    offset-x
                    min-width="400px"
                  >
                    <v-card color="grey lighten-4" width="400px" flat>
                      <v-toolbar :color="selectedEvent.color" dark>
                        <span class="text-h6 ml-2">{{ selectedEvent.name }}</span>
                      </v-toolbar>

                      <v-card-text>
                        <p><b>Horario:</b> {{ selectedEvent.start ? selectedEvent.start.replace('T', ' ').substring(11, 16) : '' }} - {{ selectedEvent.end ? selectedEvent.end.replace('T', ' ').substring(11, 16) : '' }}</p>
                        <p v-if="selectedEvent.name === 'Sesión'">
                          <b>Paciente:</b> {{ selectedEvent.patientName }} -- [ 00{{ selectedEvent.nPat }} ]
                        </p>
                        <p v-if="selectedEvent.nPat !== null">
                          <b>Paciente:</b> {{ selectedEvent.patientNameAbrev }}
                        </p>
                        <p>
                          <b>Detalle del Evento:</b> {{ selectedEvent.details }}
                        </p>
                        <p>
                          <b>Observaciones:</b> {{ selectedEvent.observations }}
                        </p>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-sheet>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </v-col>
      <v-col xs="12" sm="6" md="7" class="d-flex flex-wrap justify-center align-center">
        <v-col
          cols="8"
          xs="12"
          sm="8"
          md="6"
          class="d-flex justify-center align-center flex-wrap mb-0 pb-0"
        >
          <a
            href="https://www.freepik.es/vector-gratis/ilustracion-concepto-abstracto-servicio-psicologo-sesion-privada-psicologia-servicio-salud-mental-psicologia-familiar-terapia-infantil-psicoterapia-pareja_10780663.htm#fromView=search&page=1&position=1&uuid=cea62916-9ce7-489a-b43d-e2421608273a"
            class="white--text caption"
            v-if="$vuetify.breakpoint.xsOnly"
            >Imagen de vectorjuice en Freepik</a
          >
          <v-img
            src="@/assets/BannerProHome1.webp"
            class="d-flex justify-center align-center py-8"
          />
        </v-col>
        <v-col
          cols="8"
          xs="12"
          sm="10"
          md="6"
          class="d-flex text-body-2 grey--text text--darken-2 text-center justify-center align-center mt-sm-1 mt-md-12 pt-2 mb-10 mb-md-0"
        >
          La historia clínica estructurada garantiza una visión integral del paciente, 
          fundamentando diagnósticos precisos y planes de tratamiento eficaces. 
        </v-col>
        <v-col
          cols="8"
          xs="12"
          sm="8"
          md="6"
          class="d-flex text-body-2 grey--text text--darken-2 text-center justify-center align-center mt-sm-1 mt-md-7"
          v-if="$vuetify.breakpoint.mdAndUp"
        >
          Los tests proporcionan métricas objetivas que complementan el reporte del consultante, 
          identificando aspectos latentes no detectados en la entrevista inicial. 
        </v-col>
        <v-col
          cols="8"
          xs="12"
          sm="10"
          md="6"
          class="d-flex justify-center align-center flex-wrap mb-0 pb-0"
        >
          <a
            href="https://www.freepik.es/vector-gratis/medico-tecnicos-discutiendo-historial-medico_4949490.htm#fromView=image_search_similar&page=2&position=51&uuid=64ee65ef-6e06-496e-a738-9908b89d8850"
            class="white--text caption"
            v-if="$vuetify.breakpoint.xsOnly"
            >Imagen de vectorjuice en Freepik</a
          >
          <v-img src="@/assets/BannerProHome2.webp" />
        </v-col>
        <v-col
          cols="8"
          xs="12"
          sm="10"
          md="6"
          class="d-flex text-body-2 grey--text text--darken-2 text-center justify-center align-center mt-sm-1 mt-md-11 pt-0 mb-10 mb-md-0"
          v-if="$vuetify.breakpoint.smAndDown"
        >
          Los tests proporcionan métricas objetivas que complementan el reporte del consultante, 
          identificando aspectos latentes no detectados en la entrevista inicial. 
        </v-col>
        <v-col
          cols="8"
          xs="12"
          sm="8"
          md="6"
          class="d-flex justify-center align-center flex-wrap mb-0 pb-0"
        >
          <a
            href="https://www.freepik.es/vector-gratis/ilustracion-concepto-lista-verificacion_5573507.htm#fromView=search&page=2&position=11&uuid=04cf0202-6fb5-4148-97b1-46228acedb33"
            class="white--text caption"
            v-if="$vuetify.breakpoint.xsOnly"
            >Imagen de vectorjuice en Freepik</a
          >
          <v-img src="@/assets/BannerProHome3.webp" class="my-md-12" />
        </v-col>
        <v-col
          cols="8"
          xs="12"
          sm="10"
          md="6"
          class="d-flex text-body-2 grey--text text--darken-2 text-center justify-center align-center mt-sm-1 mt-md-11 pt-0 mb-10 mb-md-0"
        >
          Una base de datos centralizada es fundamental para la gestión clínica y la 
          elaboración de estudios de casos. Facilita la identificación de muestras para 
          investigaciones, potenciando la producción científica.        
        </v-col>
      </v-col>
    </v-row>
    <v-card-footer
      :footerItems="schema.footerItems"
      :legalItems="schema.legalItems"
      :contactItems="schema.contactItems"
      :socialNetItems="schema.socialNetItems"
    />
    <v-snack-bar :snackbar="snackbar" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VOverlayIntro from '@/components/base/VOverlayIntro.vue';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import VCardFooter from '@/components/base/VCardFooter.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'ProHomePage',
  components: {
    VOverlayIntro,
    MainHeaderPlatA,
    VCardFooter,
    VSnackBar,
  },
  data() {
    return {
      today: new Date().toLocaleDateString('sv-SE'),
      focus: new Date().toLocaleDateString('sv-SE'),
      type: 'day',
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      loadingIntro: false,
      loadingEvents: true,
    };
  },
  async mounted() {
    try {
      await this.$store.dispatch('proAppointmentsAPage/loadSchema');

      if (this.focus) {
        await this.loadEvents(this.focus);
      }
    } catch (error) {
      console.error("Error en mounted de ProHome:", error);
    } finally {
      this.loadingEvents = false;
      if (this.loadingIntro) this.loadingIntro = false;
    }
  },
  computed: {
    ...mapGetters('proHomePage', ['schema']),
    ...mapGetters('proAppointmentsAPage', ['events']),
    ...mapGetters('notifications', ['snackbar']),
  },
  methods: {
    ...mapActions('proHomePage', ['loadSchema']),
    ...mapActions('proAppointmentsAPage', ['loadEvents']),

    viewDay({ date }) {
      this.focus = date;
      this.type = 'day';
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() => requestAnimationFrame(() => (this.selectedOpen = true)));
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
  },
};
</script>